import { store } from 'app/initStore'
import { openTrigger, toggleTriggerPicker } from 'common/builder/actions/builderStateActions'
import { updateBuilderState } from 'common/builder/actions/updateBuilderState'
import { AbstractChartTriggersSerivice } from 'common/builder/components/chart/FlowChart/lib/services/ChartTriggerService/AbstractChartTriggersService'

export class ChartTriggersService extends AbstractChartTriggersSerivice {
  selectTrigger = async (triggerId: string) => {
    await Promise.allSettled([
      store.dispatch(updateBuilderState(this.builderId, { sidebarHidden: false })),
      store.dispatch(openTrigger(this.builderId, triggerId)),
    ])
  }

  createTrigger = async (source = 'startingStepNode') => {
    await store.dispatch(toggleTriggerPicker(this.builderId, { source }))
  }
}
